import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { validateIntegerParam } from '@/middleware/validateIntegerParam';
import { Dispatches } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Dispatches.Pages.DISPATCHES}`,
    name: Dispatches.Pages.DISPATCHES,
    component: () => import(/* webpackChunkName: "dispatches" */ './views/Dispatches.vue'),
    meta: {
      access_roles: RouteRoles[Dispatches.Pages.DISPATCHES],
    },
  },
  {
    path: `/${Dispatches.Pages.DISPATCHES}/:id`,
    name: Dispatches.Pages.DISPATCH_DETAIL,
    beforeEnter: validateIntegerParam('id'),
    component: () => import(/* webpackChunkName: "dispatches" */ './views/DispatchDetail.vue'),
    meta: {
      access_roles: RouteRoles[Dispatches.Pages.DISPATCH_DETAIL],
    },
  },
  {
    path: `/${Dispatches.Pages.DISPATCHES}/:id/:id`,
    name: Dispatches.Pages.DISPATCH_CORRECTIVE,
    component: () => import(/* webpackChunkName: "dispatches" */ './views/DispatchСorrective.vue'),
    meta: {
      access_roles: RouteRoles[Dispatches.Pages.DISPATCH_CORRECTIVE],
    },
  },
];

export default routes;
